import { motion } from "framer-motion";
import { IMAGES, ROADMAP } from "@/data";
import WaveDivider from "@/components/WaveDivider";
import ChapterMark from "@/components/ChapterMark";

export default function Roadmap() {
    return (
        <section id="roadmap" className="relative scroll-mt-24" data-testid="roadmap-section">
            <div className="relative py-24 md:py-32">
                <div
                    className="absolute inset-0 bg-cover bg-center opacity-15"
                    style={{ backgroundImage: `url(${IMAGES.opera})` }}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#020D18] via-transparent to-[#020D18]" />

                <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                    <div className="max-w-3xl">
                        <ChapterMark index="09" label="Expansion Goals" testid="roadmap-eyebrow" />
                        <h2 className="font-display font-semibold tracking-tight text-4xl md:text-5xl" data-testid="roadmap-heading">
                            From one Ryde contract to full Sydney coverage in six years
                        </h2>
                        <p className="mt-5 text-lg md:text-xl text-slate-400 leading-relaxed" data-testid="roadmap-intro">
                            Growth follows the contracts: prove the model in Ryde, expand across the catchment,
                            then the harbour, then greater Sydney. Once Sydney is covered, expansion stops, the
                            fleet simply maintains itself.
                        </p>
                    </div>

                    <div className="mt-14 relative" data-testid="roadmap-timeline">
                        <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-[#1C3A54]" />
                        <div className="flex flex-col gap-10">
                            {ROADMAP.map((step, i) => (
                                <motion.div
                                    key={step.year}
                                    initial={{ opacity: 0, y: 24 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, margin: "-60px" }}
                                    transition={{ duration: 0.5, delay: 0.05 }}
                                    className={`relative flex ${i % 2 === 0 ? "md:justify-start" : "md:justify-end"}`}
                                    data-testid={`roadmap-step-${i}`}
                                >
                                    <span className="absolute left-4 md:left-1/2 top-6 -translate-x-1/2 w-3 h-3 rounded-full bg-sky-300 ring-4 ring-sky-300/20" />
                                    <div className="ml-12 md:ml-0 md:w-[calc(50%-2.5rem)] bg-[#06182A]/95 border border-[#12283C] rounded-xl p-6 hover:border-sky-400/50 transition-colors">
                                        <div className="flex items-center justify-between gap-3 flex-wrap">
                                            <p className="text-sm font-semibold tracking-[0.25em] uppercase text-sky-200">{step.year}</p>
                                            <p className="text-lg font-semibold text-slate-100 font-display">{step.value}</p>
                                        </div>
                                        <p className="mt-2 font-display font-semibold text-xl">{step.title}</p>
                                        <p className="mt-2 text-base text-slate-400 leading-relaxed">{step.detail}</p>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>

                    <div className="mt-14 bg-[#05251C] border border-emerald-900/60 rounded-xl p-6" data-testid="regional-note">
                        <p className="text-sm font-semibold tracking-[0.25em] uppercase text-emerald-300">Beyond Year 10</p>
                        <p className="mt-2 text-base text-slate-300 leading-relaxed">
                            Once the Sydney model has matured and profits have grown, RiverGuardian will expand
                            into regional NSW, with the Hunter, Port Stephens and Newcastle among the first
                            targets.
                        </p>
                    </div>
                </div>
            </div>
            <WaveDivider fill="#041222" testid="roadmap-wave" />
        </section>
    );
}
